import { query } from 'src/utils/request';

// 单据列表
export const getGovernmentProjectList = async data => {
  return query('/zlb/api/expense/invest/declaration/paging', {
    method: 'POST',
    data,
  });
};

// 申报单详情
export const getGovernmentProjectDetail = async data => {
  return query('/zlb/api/expense/invest/declaration/detail', {
    method: 'POST',
    data,
  });
};

// 作废申报单
export const nullifyGovernmentProject = async data => {
  return query('/zlb/api/expense/invest/declaration/invalid', {
    method: 'POST',
    data,
  });
};

// 一致性校验
export const checkGovernmentProject = async data => {
  return query('/zlb/api/expense/invest/declaration/consistence/check', {
    method: 'POST',
    data,
  });
};

// 支付单列表
export const getPaymentOrderList = async data => {
  return query('/zlb/api/search/invest/pay-order/list', {
    method: 'POST',
    data,
  });
};
// 发起支付
export const initPaymentOrder = async data => {
  return query('/zlb/api/expense/invest/pay-order/init', {
    method: 'POST',
    data,
  });
};

// 保存支付
export const savePaymentOrder = async data => {
  return query('/zlb/api/expense/invest/pay-order/save', {
    method: 'POST',
    data,
  });
};

// 提交支付
export const submitPaymentOrder = async data => {
  return query('/zlb/api/expense/invest/pay-order/submit', {
    method: 'POST',
    data,
  });
};

// 审核支付
export const auditPaymentOrder = async data => {
  return query('/zlb/api/expense/invest/pay-order/audit', {
    method: 'POST',
    data,
  });
};

// 支付单详情
export const getPaymentOrderDetail = async params => {
  return query('/zlb/api/expense/invest/pay-order/detail', {
    method: 'GET',
    params,
  });
};

// 删除支付单
export const removePaymentOrder = async data => {
  return query('/zlb/api/expense/invest/pay-order/delete', {
    method: 'POST',
    data,
  });
};

//票据重新绑定
export const reBindBill = async data => {
  return query('/zlb/api/expense/invest/declaration/invoice/rebind', {
    method: 'POST',
    data,
  });
};
